import {ChangeDetectionStrategy, ChangeDetectorRef, Component} from '@angular/core';
import {HgTestingService} from "./hg-testing.service";
import {DetectMethodChanges} from "../utils";

@Component({
    selector: 'hg-testing-component',
    template: `
        <dx-popup title="Hg Testing Component" [visible]="this.visible"
         (onHidden)="this.onClose()">
          <div *dxTemplate="let data of 'content'">
            <dx-button text="Run Tests" (onClick)="this.runTests()"></dx-button>
          </div>
        </dx-popup>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HgTestingComponent {

    constructor(
        private readonly _changeDetector: ChangeDetectorRef,
        private readonly testingService : HgTestingService) {
    }

    visible = false;

    runTests() {
        this.testingService.run();
    }

    @DetectMethodChanges()
    show() {
        this.visible = true;
    }

    @DetectMethodChanges()
    onClose() {
        this.visible = false;
    }
}